import { SETTING_CHANGE_PRELOAD } from "../../util/mutationTypes";
import {
  INFO_TYPE_COMPLAINT,
  INFO_TYPE_FIX_CREATED,
  INFO_TYPE_LOVED_IT
} from "../../util/enumTypes";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    infoType() {
      if (this.$route.query.type == INFO_TYPE_FIX_CREATED) {
        return INFO_TYPE_FIX_CREATED;
      } else if (this.$route.query.type == INFO_TYPE_LOVED_IT) {
        return INFO_TYPE_LOVED_IT;
      }
      return INFO_TYPE_COMPLAINT;
    },
    message() {
      if (this.infoType == INFO_TYPE_FIX_CREATED) {
        return this.$t("info_fix_tour_created");
      } else if (this.infoType == INFO_TYPE_COMPLAINT) {
        return this.$t("info_message");
      } else if (this.infoType == INFO_TYPE_LOVED_IT) {
        return this.$t("info_message_loved_it");
      }
    },
    icon() {
      if (this.infoType == INFO_TYPE_FIX_CREATED) {
        return "/images/fix_tour.png";
      } else if (this.infoType == INFO_TYPE_COMPLAINT) {
        return "/images/info.png";
      } else if (this.infoType == INFO_TYPE_LOVED_IT) {
        return "/images/smile.png";
      }
    }
  },
  methods: {},
  mounted() {
    this.$store.commit(SETTING_CHANGE_PRELOAD, false);
  }
};
